




















































































































































import {Component, Prop, Vue} from "vue-property-decorator";

import {dateTimeDisplay} from "@/lib/util/dateFunctions";

import SelectDesignScenarioType from "@/modules/design/views/components/SelectDesignScenarioType.vue";
import {DesignScenarioType} from "@/modules/design/interfaces/shared";
import {BaseScenarioType, IBaseScenario, IDesignBaseScenario} from "@/lib/types/IBaseScenario";
import {IProjectMetadata} from "@/interfaces/report";
import {createNewFullLcca} from "@/modules/lcca/lib/createNew";
import {agencyStore, designStore, lccaStore, perRoadStore, structureStore} from "@/store/store";
import router from "@/router";
import {createNewAgencyCostScenario} from "@/modules/agencyCost/lib/createNew";
import {createNewPerRoadScenario} from "@/modules/perRoad/lib/createNew";
import ShareScenarioModal from "@/views/components/input/ShareScenarioModal.vue";
import {createNewPavementStructureScenario} from "@/modules/structure/lib/createNew";

@Component({
  components: {ShareScenarioModal, SelectDesignScenarioType},
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: null,
    },
  },
})
export default class ScenarioContainer extends Vue {
  @Prop({required: true, default: []}) scenarios!: IBaseScenario[];

  @Prop({
    default: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, "
        + "sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  }) readonly description!: string;

  @Prop() pxProjectId!: number;

  @Prop() projectMetadata!: IProjectMetadata;

  @Prop() id!: string;

  dateColDisplay(isoDate: string) {
    return dateTimeDisplay(isoDate);
  }

  scenarioTypes = BaseScenarioType;

  get fields() {
    if (this.id === BaseScenarioType.design) {
      return [
        {key: "name", sortable: true},
        // { key: 'created', sortable: true },
        {key: "modified", label: "Last Modified", sortable: true},
        {key: "scenarioType", sortable: true},
        {key: "actions"},
      ];
    }

    if (this.id === BaseScenarioType.lcca) {
      return [
        {key: "name", sortable: true},
        // { key: 'created', sortable: true },
        {key: "modified", label: "Last Modified", sortable: true},
        {key: "actions"},
      ];
    }

    if (this.id === BaseScenarioType.agencyCost) {
      return [
        {key: "select", label: "Compare", sortable: true},
        {key: "name", sortable: true},
        // { key: 'created', sortable: true },
        {key: "modified", label: "Last Modified", sortable: true},
        {key: "actions"},
      ];
    }

    if (this.id === BaseScenarioType.perRoad) {
      return [
        {key: "name", sortable: true},
        // { key: 'created', sortable: true },
        {key: "modified", label: "Last Modified", sortable: true},
        // { key: 'scenarioType', sortable: true },
        {key: "actions"},
      ];
    }

    if (this.id === BaseScenarioType.structure) {
      return [
        {key: "name", sortable: true},
        // { key: 'created', sortable: true },
        {key: "modified", label: "Last Modified", sortable: true},
        // { key: 'scenarioType', sortable: true },
        {key: "actions"},
      ];
    }

    return [];
  }

  openDeleteModal(scenario: IBaseScenario | IDesignBaseScenario): void {
    // const project = this.getFullProject(id);
    this.$bvModal.msgBoxConfirm(`Are you sure you want to delete the scenario${scenario.name}?`)
        .then((value) => {
          if (value === true) {
            if (scenario.scenarioType === BaseScenarioType.design) {
              const url = this.urlKey(scenario).value;
              // @ts-ignore
              designStore.deleteScenario({scenario, urlKey: url}).then((result) => {
                if (result !== null) {
                  this.$emit("deleteScenario");
                }
              });
            } else if (scenario.scenarioType === BaseScenarioType.lcca) {
              lccaStore.deleteScenario(scenario).then((result) => {
                if (result !== null) {
                  this.$emit("deleteScenario");
                }
              });
            } else if (scenario.scenarioType === BaseScenarioType.agencyCost) {
              agencyStore.deleteScenario(scenario).then((result) => {
                if (result !== null) {
                  this.$emit("deleteScenario");
                }
              });
            } else if (scenario.scenarioType === BaseScenarioType.perRoad) {
              perRoadStore.deleteScenario(scenario).then(result => {
                if (result !== null) {
                  this.$emit("deleteScenario");
                }
              });
            } else if (scenario.scenarioType === BaseScenarioType.structure) {
              structureStore.deleteScenario(scenario).then(result => {
                if (result !== null) {
                  this.$emit("deleteScenario");
                }
              });
            }
          }
        });
  }

  createNew(scenarioType: BaseScenarioType) {
    if (scenarioType === BaseScenarioType.lcca) {
      // const newScenario = createNewLcca(this.projectMetadata);
      const newScenario = createNewFullLcca(this.projectMetadata);
      lccaStore.saveNewScenario(newScenario).then((savedScenario) => {
        if (savedScenario) {
          router.push(`lcca/${savedScenario.id}/1`);
        }
      });
    } else if (scenarioType === BaseScenarioType.agencyCost) {
      const newScenario = createNewAgencyCostScenario(this.projectMetadata);
      agencyStore.saveNewScenario(newScenario).then((savedScenario) => {
        if (savedScenario) {
          router.push(`agency/${savedScenario.id}/1`);
        }
      });
    } else if (scenarioType === BaseScenarioType.perRoad) {
      const newScenario = createNewPerRoadScenario(this.projectMetadata);
      perRoadStore.saveNewScenario(newScenario).then((savedScenario) => {
        if (savedScenario) {
          router.push(`perroad/${savedScenario.id}/1`);
        }
      });
      // router.push(`perroad/${newScenario.id}/1`);
    } else if (scenarioType === BaseScenarioType.structure) {
      const newScenario = createNewPavementStructureScenario(this.projectMetadata);
      structureStore.saveNewScenario(newScenario).then((savedScenario) => {
        if (savedScenario) {
          router.push(`structure/${savedScenario.id}/1`);
        }
      });
    }
  }

  urlKey(scenarioMetadata: any): { value: string, text: string } {
    // console.log(scenarioMetadata.name, scenarioMetadata.designScenarioType);
    if (scenarioMetadata.scenarioType === BaseScenarioType.design) {
      switch (scenarioMetadata.designScenarioType) {
        case DesignScenarioType.asphalt:
          return {value: "asphalt", text: scenarioMetadata.designScenarioType};
        case DesignScenarioType.concrete:
          return {value: "concrete", text: scenarioMetadata.designScenarioType};
        case DesignScenarioType.porous:
          return {value: "porous", text: scenarioMetadata.designScenarioType};
        case DesignScenarioType.acOverlay:
          return {value: "ac-overlay", text: scenarioMetadata.designScenarioType};
        default:
          return {value: "[none]", text: "[none]"};
      }
    } else if (scenarioMetadata.scenarioType === BaseScenarioType.lcca) {
      return {value: "lcca", text: "LCCA"};
    } else if (scenarioMetadata.scenarioType === BaseScenarioType.agencyCost) {
      return {value: "agency", text: "Agency Cost"};
    } else if (scenarioMetadata.scenarioType === BaseScenarioType.perRoad) {
      return {value: "perroad", text: "PerRoad"};
    } else if (scenarioMetadata.scenarioType === BaseScenarioType.structure) {
      return {value: "structure", text: "Structure"};
    }

    console.log(scenarioMetadata.scenarioType);
    return {value: "[none]", text: "[none]"};
  }

  get selectedAgencyCostIds() {
    // @ts-ignore
    const selectedIds = this.scenarios.filter((s) => s.selected && s.id).map((s) => s.id);
    return selectedIds;
  }

  compareSelectedAgencyCost() {
    // @ts-ignore
    agencyStore.setComparisonIds(this.selectedAgencyCostIds);

    this.$router.push({path: "/agency/compare", query: {scenarios: this.selectedAgencyCostIds.join(",")}});
  }
}
